<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="analyze-app">
    <!-- <vx-card :title="'Sale Performance - Last '+ activeTimeline.days +' days'" class="mb-base"> -->
      <vx-card :title="'Sales Performance - '+ dateSpan()">
      <template slot="actions">
        <div class="btn-group">
          <vs-button
            radius
            type="line"
            v-for="tl in timeline"
            :key="tl.days"
            v-bind="{disabled : tl.block}"
            @click="timelineLookup(tl)"
            size="small"
            :color="tl.selected ? colors.primary : '#aaa'"
          >{{tl.label}}</vs-button>
        </div>
      </template>
      <!-- <pre>{{artefact.res.trend.current}}</pre> -->
      <!-- <vs-alert active="true" :color="colors.note" class="mb-3" icon-pack="feather" icon="icon-alert-triangle">
      <strong>Sale Performance</strong> - Last {{activeTimeline.days}} days
      </vs-alert>-->
      <!-- Current Month Stats -->
      <!-- <vx-card title="Sale Performance - Month Till Date" class="mb-base"> -->
      <div class="vx-row">
        <div class="vx-col w-full" v-if="envMode === 'lite'">
          <div class="vx-row">
            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/5">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="DollarSignIcon"
                :statistic="Math.round(dashboard.overall[0].retail_price) | numFormat('$ 0,0')"
                statisticTitle="$ Sales"
                color="success"
              />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/5">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="PackageIcon"
                :statistic="dashboard.overall[0].quantity | numFormat"
                statisticTitle="Unit Sales"
                color="primary"
              />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/5">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="ShoppingBagIcon"
                :statistic="dashboard.overall[0].checkouts | numFormat"
                statisticTitle="Basket Checkouts"
                color="warning"
              />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/5">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="DollarSignIcon"
                :statistic="dashboard.overall[0].basket_value | numFormat('$ 0,0.00')"
                statisticTitle="Avg. Basket Value"
                color="warning"
              />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/5">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="BoxIcon"
                :statistic="dashboard.overall[0].basket_size | numFormat('0.00')"
                statisticTitle="Avg. Basket Size"
                color="warning"
              />
            </div>

            <!-- <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="TagIcon"
                :statistic="dashboard.overall[0].items | numFormat"
                statisticTitle="Scanned"
                color="dark"
              />
            </div> -->
          </div>
        </div>

        <div class="vx-col w-full" v-if="envMode !== 'lite'">
          <!-- <vx-card title="Current month sales" card-background="primary" title-color="#fff"> -->
          <!-- <vx-card title="Sale Performance - Month Till Date"> -->
          <!-- <vs-alert active="true" class="mb-base" icon-pack="feather" icon="icon-star">
            Chupa chups topping bonbon. Jelly-o toffee I love. Sweet I love wafer I love wafer.
          </vs-alert>-->
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="DollarSignIcon"
                  :statistic="Math.round(dashboard.overall[0].retail_price) | numFormat('$ 0,0')"
                  statisticTitle="Dollar Sales"
                  :chartData="statChartData"
                  color="success"
                  icon-right
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="PackageIcon"
                  :statistic="dashboard.overall[0].quantity | numFormat"
                  statisticTitle="Unit Sales"
                  :chartData="statChartData"
                  color="primary"
                  icon-right
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="TagIcon"
                  :statistic="Math.round(dashboard.overall[0].items) | numFormat('0,0')"
                  statisticTitle="Scanned Items"
                  :chartData="statChartData"
                  color="dark"
                  icon-right
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="TruckIcon"
                  :statistic="dashboard.overall[0].inventory | numFormat"
                  statisticTitle="Current Inventory"
                  :chartData="statChartData"
                  color="danger"
                  icon-right
                ></statistics-card-line>
              </div>
            </div>
          </div>
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="DollarSignIcon"
                  :statistic="dashboard.overall[0].basket_value | numFormat('$ 0,0.00')"
                  statisticTitle="Dollar Sales / Checkout"
                  color="warning"
                  icon-right
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="BoxIcon"
                  :statistic="dashboard.overall[0].basket_size | numFormat('0.00')"
                  statisticTitle="Unit Sales / Checkout"
                  :chartData="statChartData"
                  color="warning"
                  icon-right
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="ShoppingBagIcon"
                  :statistic="dashboard.overall[0].checkouts | numFormat"
                  statisticTitle="Checkouts"
                  :chartData="statChartData"
                  color="warning"
                  icon-right
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-2"
                  icon="DollarSignIcon"
                  :statistic="Math.round(dashboard.overall[0].cost_to_company) | numFormat('$ 0,0')"
                  statisticTitle="Cost to Company"
                  :chartData="statChartData"
                  color="danger"
                  icon-right
                ></statistics-card-line>
              </div>
            </div>
          </div>
          <!-- </vx-card> -->
        </div>
      </div>
      <!-- </vx-card> -->

      <!-- Trend Stats -->
      <vs-alert
        active="true"
        :color="colors.note"
        class="mb-3"
        icon-pack="feather"
        icon="icon-activity"
      >
        <strong>Sales Trend</strong>
        - {{dateSpan()}}
      </vs-alert>

      <!-- <vx-card title="Sale Trend" subtitle="- Last 90 days"> -->
      <!-- <vs-alert
        active="true"
        :color="colors.note"
        class="mb-2"
        icon-pack="feather"
        icon="icon-activity"
      >- Last 90 days</vs-alert>-->
      <div v-if="envMode === 'lite'">
        <div class="vx-row" v-if="dashboard.trend.length > 0">
          <div class="vx-col w-full mb-2">
            <vx-card title="Baskets Checked out">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineTrans.chartOptions"
                  :series="buildSeriesData('checkouts', 'Checkouts')"
                />
              </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row" v-if="dashboard.trend.length > 0">
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Avg. Basket Value">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineRPO.chartOptions"
                  :series="buildSeriesData('basket_value', 'Dollar Sales / Checkout')"
                />
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Avg. Basket Size">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineUPO.chartOptions"
                  :series="buildSeriesData('basket_size', 'Unit Sales / Checkout')"
                />
              </div>
            </vx-card>
          </div>
          <!-- <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
            <vx-card title="Basket Size">
              <template slot="actions">
                <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineInventory.chartOptions"
                  :series="buildSeriesData('inventory', 'Basket Size')"
                />
              </div>
            </vx-card>
          </div>-->
        </div>
        <div class="vx-row" v-if="dashboard.trend.length > 0">
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="$ Sales">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineRev.chartOptions"
                  :series="buildSeriesData('retail_price', 'Dollar Sales')"
                />
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Unit Sales">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineQty.chartOptions"
                  :series="buildSeriesData('quantity', 'Unit Sales')"
                />
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div v-if="envMode !== 'lite'">
        <div class="vx-row" v-if="dashboard.trend.length > 0">
          <div class="vx-col w-full mb-2">
            <vx-card title="Checkouts">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineTrans.chartOptions"
                  :series="buildSeriesData('checkouts', 'Checkouts')"
                />
              </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row" v-if="dashboard.trend.length > 0">
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Dollar Sales / Checkout">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineRPO.chartOptions"
                  :series="buildSeriesData('basket_value', 'Dollar Sales / Checkout')"
                />
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Unit Sales / Checkout">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineUPO.chartOptions"
                  :series="buildSeriesData('basket_size', 'Unit Sales / Checkout')"
                />
              </div>
            </vx-card>
          </div>
          <!-- <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
            <vx-card title="Basket Size">
              <template slot="actions">
                <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineInventory.chartOptions"
                  :series="buildSeriesData('inventory', 'Basket Size')"
                />
              </div>
            </vx-card>
          </div>-->
        </div>
        <div class="vx-row" v-if="dashboard.trend.length > 0">
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Dollar Sales">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineRev.chartOptions"
                  :series="buildSeriesData('retail_price', 'Dollar Sales')"
                />
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
            <vx-card title="Unit Sales">
              <template slot="actions">
                <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
              </template>
              <div slot="no-body" class="p-6 pb-0">
                <vue-apex-charts
                  type="line"
                  height="266"
                  :options="trendLineQty.chartOptions"
                  :series="buildSeriesData('quantity', 'Unit Sales')"
                />
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <!-- </vx-card> -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";

import { appCommons } from "@/app/shared/services";
import appConfig from "@/../appConfig.js";

import { actionsTypes } from "../shared/state";

const themeColors = appConfig.chart.colors;

export default {
  data() {
    return {
      envMode: appConfig.config.env,
      isNavOpen: false,
      type: "all",
      activeSearch: null,
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7,
      },
      wasSidebarOpen: null,
      colors: appConfig.colors,
      timeline: [
        {
          label: "1 d",
          desc: "1 day",
          days: 1,
          selected: false,
        },
        {
          label: "1 w",
          desc: "1 week",
          days: 7,
          selected: false,
        },
        {
          label: "2 w",
          desc: "2 weeks",
          days: 14,
          selected: true,
        },
        {
          label: "4 w",
          desc: "4 weeks",
          days: 28,
          selected: false,
        }, 
        {
          label: "5 w",
          desc: "5 weeks",
          days: 35,
          selected: false
        },
        {
          label: "13 w",
          desc: "13 weeks",
          days: 91,
          selected: false,
        },
        {
          label: "26 w",
          desc: "26 weeks",
          days: 182,
          selected: false,
        },
        {
          label: "52 w",
          desc: "52 weeks",
          days: 364,
          selected: false,
        },
      ],
      activeTimeline: {
        label: "2 w",
        desc: "2 weeks",
        days: 14,
        selected: true,
      },
      payload: {
        tags: [],
        dateRange: appCommons.allowedDateScope("", 14, "minus"),
        query: "",
        mode: "",
        type: "DASH",
        res: {},
      },
      isLoading: false,
      statChartData: {},
      trendLineRPO: {
        series: [
          {
            name: "",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2],
          },
          grid: {
            borderColor: "#ebebeb",
          },
          legend: {
            show: false,
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Days",
              // offsetY: 10,
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : val.toFixed(2);
              },
            },
            title: {
              text:
                "Sales ( " + this.$options.filters.currencySymbol("") + " )",
              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
          },
          tooltip: {
            x: { show: false }
          },
        },
      },
      trendLineUPO: {
        series: [
          {
            name: "",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2],
          },
          grid: {
            borderColor: "#ebebeb",
          },
          legend: {
            show: false,
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Days",
              // offsetY: 10,
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : val.toFixed(2);
              },
            },
            title: {
              text: "# Units",
              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      trendLineInventory: {
        series: [
          {
            name: "",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2],
          },
          grid: {
            borderColor: "#ebebeb",
          },
          legend: {
            show: false,
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Days",
              // offsetY: 10,
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : val.toFixed(0);
              },
            },
            title: {
              text: "# Units (Avg.)",
              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      trendLineQty: {
        series: [
          {
            name: "",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2],
          },
          grid: {
            borderColor: "#ebebeb",
          },
          legend: {
            show: false,
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Days",
              // offsetY: 10,
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : val.toFixed(0);
              },
            },
            title: {
              text: "# Units",
              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      trendLineRev: {
        series: [
          {
            name: "",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2],
          },
          grid: {
            borderColor: "#ebebeb",
          },
          legend: {
            show: false,
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Days",
              // offsetY: 10,
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : val.toFixed(0);
              },
            },
            title: {
              text:
                "Sales ( " + this.$options.filters.currencySymbol("") + " )",
              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      trendLineTrans: {
        series: [
          {
            name: "",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2],
          },
          grid: {
            borderColor: "#ebebeb",
          },
          legend: {
            show: false,
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            type: "datetime",
            tickAmount: 5,
            title: {
              text: "Days",
              // offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : val.toFixed(0);
              },
            },
            title: {
              text: "# Transactions",
              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
          },
          tooltip: {
            x: {
              show: false,
              // format: "dd MMM yyyy",
            }
          },
        },
      },
    };
  },
  methods: {
    init() {
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#analyze-app",
        // scale: 0.45,
        type: "radius",
      });

      this.payload.dateRange = appCommons.allowedDateScope(
        "",
        this.activeTimeline.days,
        "minus"
      );

      this.$store.dispatch(
        "analyze/" + actionsTypes.FETCH_ANALYZE_ARTEFACT,
        this.payload
      );
    },
    timelineLookup(tl) {
      for (var t of this.timeline) {
        if (t.days === tl.days) {
          t.selected = true;
          this.activeTimeline = t;
        } else {
          t.selected = false;
        }
      }
      this.init();
    },
    buildSeriesData(type, name) {
      let series = [];

      let filteredUnitDataTrend = [
        {
          name: name,
          data: [],
        },
      ];

      let filteredActual = this.filterAndSortData(this.dashboard.trend, type);

      let maxWeeksActual =
        this.dashboard && this.dashboard.trend
          ? this.dashboard.trend.length
          : 0; //appCommons.countOfUnitsBetweenDates('week', this.payload.dateRange.startDate, this.payload.dateRange.endDate);

      filteredUnitDataTrend.data = this.buildseriesOfGroup(
        type,
        maxWeeksActual,
        filteredActual,
        filteredActual[0].sale_year
      );

      series.push(filteredUnitDataTrend);

      return series;
    },
    filterAndSortData(data, type) {
      let filteredData = [];
      Object.assign(filteredData, data);

      return filteredData.sort(function (t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        var date1 = t1.sale_date;
        var date2 = t2.sale_date;

        if (date1 && date2) {
          if (date1 < date2) {
            return -1;
          }
          if (date1 > date2) {
            return 1;
          }
        } else {
          if (year1 < year2 && week1 < week2) {
            return -1;
          }
          if (year1 > year2 && week1 > week2) {
            return 1;
          }
        }
        // tags must be equal
        return 0;
      });
    },
    buildseriesOfGroup1(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek + 1)
            .startOf("isoWeek")
            .format("MM-DD-YYYY");

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");
          let y = groupedUnit[weekIndex][type]
            ? groupedUnit[weekIndex][type]
            : 0;

          series.push({
            x: x,
            y: this.$options.filters.numFormat(y, "0.00"),
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(currentWeek === 1 ? ++currentYear : currentYear)
            .isoWeek(currentWeek + 1)
            .startOf("isoWeek")
            .format("MM-DD-YYYY");

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0.00";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y,
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },
    buildseriesOfGroup(type, maxWeeks, groupedUnit, startYear) {
      let series = [];

      for (let unit of groupedUnit) {
        //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
        // let x = this.$moment(unit.sale_date, "YYYY-MM-DD").format("MM-DD-YYYY");
        const x = new Date(unit.sale_date);
        // let x =
        //   "w" +
        //   currentWeek +
        //   (prevWeek > currentWeek ? " '" + currentYear : "");
        let y = unit[type] ? unit[type] : 0;

        series.push({
          x: x.getTime(),
          y: this.$options.filters.numFormat(y, "0.00"),
        });
      }

      // console.log('buildseriesOfGroup > series', series);

      return series;
    },
    dateSpan() {
      const dateRange = appCommons.allowedDateScope("", this.activeTimeline.days, "minus");
      let days = "Last day ( "+ (this.$options.filters.date(dateRange.endDate)) + " )";
      if(this.activeTimeline.days === 0) {
        days = "Today ( "+ (this.$options.filters.date(dateRange.endDate)) + " )";
      } else if(this.activeTimeline.days > 1) {
        days = "Last " + this.activeTimeline.desc + " ( "+(this.$options.filters.date(dateRange.startDate)) +" - "+ (this.$options.filters.date(dateRange.endDate))+" )";
      }
      return days;
    }
  },
  computed: {
    dashboard() {
      let dash = {"overall": [{"revenue": 0.0, "retail_price": 0.0, "items": 0, "checkouts": 0, "quantity": 0, "basket_size": 0.0, "basket_value": 0.0, "basket_value_sum": 0.0, "basket_size_sum": 0.0, "inventory": 0.0, "cost_to_company": 0.0}], "trend": []}

      return this.artefact && this.artefact.res ? this.artefact.res : dash;
    },
    ...mapGetters({ artefact: "analyze/artefact" }),
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.filterReset = true;

    this.$store.watch(
      (state, getters) => getters["analyze/isLoading"],
      (newValue, oldValue) => {
        this.isLoading = newValue;
        if (this.isLoading) {
          this.$vs.loading({
            // background: this.backgroundLoading,
            // color: this.colorLoading,
            // container: "#analyze-app",
            // scale: 0.45,
            type: "radius",
          });
        }

        if (!this.isLoading) {
          this.$vs.loading.close();
          // this.$vs.loading.close("#analyze-app > .con-vs-loading");
        }
      }
    );
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    },
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
  },
};
</script>

<style lang="scss">
#analyze-app {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
